export default __webpack_public_path__ + "assets/82e6b7e1ceeb1c933f7a3e68ec578406/amenities-02.jpg";